/* OzCamps — subtle scroll-reveal for product-page sections.
   Lightweight (no library), respects prefers-reduced-motion, and FAILS OPEN:
   the hidden state only applies once this script adds `oz-anim` to <html>, so
   if the script never runs, all content stays visible (no stuck-hidden boxes).
   Pairs with the .oz-reveal / .oz-in CSS in custom-product-typography.css. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var body = document.body;
    if (!body || !/template-product|template-index/.test(body.className)) return;

    document.documentElement.classList.add('oz-anim');
    window.__ozAnim = true;

    /* Custom OzCamps sections — styled directly in CSS, just need observing. */
    var KNOWN = '.oztp-card,.oztp-header,.ozcamps-ba__cell,.ozcamps-ba__header,'
              + '.oz-shead__pill,.oz-shead__heading,.oz-shead__sub';
    var els = [].slice.call(document.querySelectorAll(KNOWN));

    /* Theme content sections below the buy box — reveal each section's content
       block as a whole. Skip the header/footer/announcement, the buy box, and
       the reviews widget (Loox renders async). */
    var SKIP = /__main\b|17694373196876ac1c|17694405611f8bcad5|announcement|header|footer|hero[_-]promo/i;
    [].forEach.call(document.querySelectorAll('.shopify-section'), function (sec) {
      if (SKIP.test(sec.id)) return;
      var inner = sec.querySelector(':scope > div, :scope > section');
      if (!inner) return;
      if (inner.matches('.oztp, .ozcamps-ba, .oz-shead')) return; /* mine, handled above */
      inner.classList.add('oz-reveal');
      els.push(inner);
    });

    /* Gentle stagger inside the bento / before-after grids. */
    [['.oztp-grid', '.oztp-card'], ['.ozcamps-ba__grid', '.ozcamps-ba__cell']].forEach(function (pair) {
      [].forEach.call(document.querySelectorAll(pair[0]), function (grid) {
        [].forEach.call(grid.querySelectorAll(pair[1]), function (card, i) {
          card.style.setProperty('--oz-delay', (i * 80) + 'ms');
        });
      });
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('oz-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('oz-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });

    /* Failsafe: reveal anything still hidden after a few seconds. */
    setTimeout(function () { els.forEach(function (e) { e.classList.add('oz-in'); }); }, 3000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
